








import {Component, Prop, Vue} from 'vue-property-decorator'

export enum NotificationLevel {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error'
}

@Component
export default class NotificationMessage extends Vue {
    @Prop()
    level!: NotificationLevel;

    @Prop()
    message!: string;

    private isShown: boolean = true;

    private get levelClass(): string {
        switch (this.level) {
            case NotificationLevel.SUCCESS:
                return 'success';
            case NotificationLevel.WARNING:
                return 'warning';
            case NotificationLevel.ERROR:
                return 'error';
        }
    }
}
